module.exports = __webpack_public_path__ + "img/BMW.f0a3fdda.png";